import React, { useEffect, useState } from "react";
import axios from "axios";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TableShimmer from "../../screens/components/TableShimmer";

import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { getUserList, destroyUser } from "../../api/userService";
import Avatar from "../../assets/img/default.jpg";
const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

const OLT_icon = "https://d3bn54rc14fhr4.cloudfront.net/ss.png";
export default function Users() {
  const [searchText, setSearchText] = useState("");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [userToDelete, setUserToDelete] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    fetchUsers(currentPage, pageSize);
  }, [searchText, currentPage, pageSize]);

  const fetchUsers = (page, size) => {
    setLoading(true);
    getUserList({ page, limit: size, search: searchText })
      .then((response) => {
        if (response.code === 200) {
          setUsers(response.data);
          setTotalUsers(response.pagination.totalUsers);
        }
      })
      .catch((error) => console.error("Error fetching users", error))
      .finally(() => setLoading(false));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDeleteUser = () => {
    if (!userToDelete) return;

    destroyUser(userToDelete)
      .then((response) => {
        if (response.code === 200) {
          setUsers((prevUsers) =>
            prevUsers.filter((user) => user._id !== userToDelete)
          );
          setShow(false);
          setUserToDelete(null);
        }
      })
      .catch((error) => {
        console.error("Error deleting user", error);
        alert("Failed to delete user. Please try again.");
      });
  };

  const handleShowDeleteModal = (id) => {
    setUserToDelete(id);
    setShow(true);
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "Active":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      case "Inactive":
        return {
          backgroundColor: "rgba(146, 0, 0, 0.12)",
          color: "#920000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };

  const columns = [
    {
      name: 'SR No.',
      width: '80px',
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
      sortable: false,
    },
    {
      name: "Image",
      width: "100px",
      selector: (row) => row.profilePic,
      sortable: true,
      cell: (row) => {
        const isInactive = row.accountStatus === "Inactive";
        const profileSrc = isInactive
          ? Avatar
          : row.profilePic
          ? `${MEDIA_URL}/${row.profilePic}`
          : OLT_icon;

        return (
          <>
            <img
              className="table_img rounded-circle img-thumbnail me-2"
              src={profileSrc}
              alt="profile"
            />
          </>
        );
      },
    },
    {
      name: "Name",
      width: "150px",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => {
        const isInactive = row.accountStatus === "Inactive";
        const profileSrc = isInactive
          ? Avatar
          : row.profilePic
          ? `${MEDIA_URL}/${row.profilePic}`
          : OLT_icon;

        return (
          <>
            {row.fullName}
          </>
        );
      },
    },
    {
      name: "Username",
      width: "150px",
      selector: (row) => row.username,
      sortable: true,
      cell: (row) => {
        const isInactive = row.accountStatus === "Inactive";
        return (
          <>
            {row.username}
          </>
        );
      },
    },
    {
      name: "Contact Info",
      width: "300px",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => (
        <div>
          <div>{row.email}</div>
          {row.countryCode && row.mobileNumber && (
            <div className="text-muted small">
              +{row.countryCode} {row.mobileNumber}
            </div>
          )}
        </div>
      ),
    },
    // {
    //   name: "Phone No.",
    //   width: "180px",
    //   selector: (row) => row.mobileNumber,
    //   sortable: true,
    //   cell: (row) => row.mobileNumber,
    // },
    {
      name: "Status",
      width: "180px",
      selector: (row) => row.accountStatus,
      sortable: true,
      cell: (row) => (
        <span style={getStatusStyle(row.accountStatus)}>
          {row.accountStatus === "Inactive"
            ? "Deleted user"
            : row.accountStatus}
        </span>
      ),
    },
    // {
    //   name: "Registration Date",
    //   width: "180px",
    //   selector: (row) => new Date(row.createdAt).toLocaleDateString(),
    //   sortable: true,
    //   cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    // },
    {
      name: "Registered on",
      width: "260px",
      selector: (row) =>
        row.updatedAt ? new Date(row.createdAt).toLocaleDateString() : "N/A",
      sortable: true,
      cell: (row) =>
        row.updatedAt ? new Date(row.createdAt).toLocaleDateString() : "N/A",
    },
    // {
    //   name: "Subscription Status",
    //   width: "200px",
    //   selector: (row) => row.SubscriptionStatus || "N/A",
    //   sortable: true,
    //   cell: (row) => row.SubscriptionStatus || "N/A",
    // },
    {
      name: "Actions",
      width: "210px",
      cell: (row) => (
        <>
          <Link
            className="btnview"
            to={`/admin/view-user/${row._id}?tab=basicinfo`}
          >
            <Icon icon="tabler:eye"></Icon>
          </Link>
          <Link className="btnedit" to={`/admin/update-profile/${row._id}`}>
            <Icon icon="tabler:pencil"></Icon>
          </Link>
          {/* <Link
            className="btndelete"
            onClick={() => handleShowDeleteModal(row._id)}
          >
            <Icon icon="tabler:trash"></Icon>
          </Link> */}
        </>
      ),
    },
  ];

  const filteredData = users.filter(
    (user) =>
      (user.fullName &&
        user.fullName.toLowerCase().includes(searchText.toLowerCase())) ||
      (user.email &&
        user.email.toLowerCase().includes(searchText.toLowerCase())) ||
      (user.mobileNumber && user.mobileNumber.includes(searchText))
  );

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
              <h5>Users</h5>
              <Button
                className="btn btn-primary-light px-4 min_width140"
                as={Link}
                to="/add-user"
              >
                Add
              </Button>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {/* {filteredData.length === 0 ? ( 
                <p className="text-center">Loading...</p>
              ) : ( */}
              <DataTable
                columns={columns}
                data={loading ? [] : filteredData}
                progressPending={loading}
                progressComponent={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                      width: "100%",
                    }}
                  >
                    <TailSpin height={50} width={80} color="#4fa94d" />
                  </div>
                }
                pagination
                paginationServer
                paginationTotalRows={totalUsers}
                paginationPerPage={pageSize}
                onChangePage={handlePageChange}
                responsive
                className="custom-table"
                noDataComponent={
                  <p className="text-center my-4">No users found</p>
                }
              />
              {/* )} */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o"></Icon>
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            onClick={handleClose}
            className="btn btn-primary-outline px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary px-4 min_width110"
            onClick={handleDeleteUser}
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
